// extracted by mini-css-extract-plugin
export var bellring = "Q_cF";
export var boxErrorContainer = "Q_cy";
export var boxErrorWrapper = "Q_cD";
export var boxErrordanger = "Q_cC";
export var boxErrorinfo = "Q_cz";
export var boxErrorwarning = "Q_cB";